// import simpleParallax from 'simple-parallax-js'
import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
// import 'motion-ui/dist/motion-ui'
import AOS from 'aos'
import throttle from 'lodash/throttle';
// import '../../node_modules/jquery-parallax.js/parallax.min.js'
// import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange, } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
// import './_acf-map'
import './_fixed-header'
// import './_header-height'
// import './_hero-slider'
// import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
// import './_faqs_accordion'
import './_fragmentURLs'

/* Additional Scripts */
// import { randomString } from './_random-string'
import './_ie'


// Foundation
$(document).foundation();

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {
    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    lazyOembeds();
    lazyInterchange();
     
    // reveal the first section below the hero on the homepage
    if ( document.body.classList.contains('home') ) {
        setTimeout( () => document.body.classList.add('page-has-loaded') , 250 );
    }
}, false);

// Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );


// AOS
AOS.init();


// gfield visibility and upload hack
var $contact_upload_field = $('#field_2_10');
$contact_upload_field.css( 'display', 'none' );

$('#input_2_9').change( function( events ) {
    if ( this.value == 'I\'d like to work for World Wave Events' ) {
        $contact_upload_field.css( 'display', 'list-item' );
        $contact_upload_field.find('input[type="file"]').removeAttr('disabled');
        $('#gform_browse_button_2_10').removeAttr('disabled');
    }
});

/**
 * Edge Background - Remove the video and added the background
 */
if ( $('body').hasClass('is-edge') || $('body').hasClass('is-ie') ) {
    var edgeBG = $('#edge-background').attr('data-hero-bg');
    $('video.hero__background-video').remove();
    $('.hero.hero--advanced').prepend(`
        <div
            aria-hidden="true"
            class="hero__background js-hero-background" 
            style="background-color: #0067A6; background-image: url('${edgeBG}')">
        </div>
    `);
}
